import { trackEvent } from "./omega";
// 性能指标上报
(function() {
  const performanceMetricMap: Record<string, number> = {};
  // 过滤自定义指标
  function filterEntry(name: string) {
    if (['_P1', '_P2', '_P3', '_P4'].some((suffix) => name.endsWith(suffix))) return true;  
    return false;
  }

  /**
   * 只记录第一次
   */
  function cacheCustomEntry(key: string, value: number) {
    if (!performanceMetricMap[key]) {
      performanceMetricMap[key] = value
    }
  }
  // 上报自定义指标
  function report() {
    for (const key in performanceMetricMap) {
      const duration = performanceMetricMap[key];
      trackEvent('tech_performance_custom', {
        // mas 埋点属性
        timingCategory: key,
        timingName: key,
        timingValue: duration,
        // omega埋点属性
        timing_category: key,
        timing_name: key,
        timing_value: duration,
        page_path: window.location.pathname,
      });
      // 上报完清空缓存，避免重复上报
      delete performanceMetricMap[key];
    }
  }

  try {
    // 监听性能指标变化
    const observer = new PerformanceObserver(function (list) {
      const entries = list.getEntries();
      // 页面路径，作为指标的key前缀
      const pageKey = window.location.pathname.replace(/\//g, '_').slice(1).toLocaleUpperCase();
      // 遍历所有性能指标
      for (let i = 0; i < entries.length; i++) {
        const entry = entries[i]
        // 记录自定义指标
        if (filterEntry(entry.name)) {
          cacheCustomEntry(pageKey ? `${pageKey}_${entry.name}` : entry.name, entry.startTime)
        }
        // 首字节时长
        if (entry.entryType === 'navigation') {
          const TTFB = (entry as PerformanceNavigationTiming).responseStart;
          cacheCustomEntry(pageKey ? `${pageKey}_TTFB` : 'TTFB', TTFB)
          const responseEnd = (entry as PerformanceNavigationTiming).responseEnd;
          cacheCustomEntry(pageKey ? `${pageKey}_P2` : 'P2', responseEnd)
        }
        // 最大内容ful paint
        if (entry.entryType === 'largest-contentful-paint') {
          cacheCustomEntry(pageKey ? `${pageKey}_LCP` : 'LCP', (entry as any).startTime)
        }
      }
    });

    observer.observe({
      entryTypes: ['mark', 'navigation', 'largest-contentful-paint'],
      buffered: true,
    });

    const stopListening = () => {
      report();
      observer?.disconnect();
    }
    // 监听键盘事件和点击事件，上报指标
    ['keydown', 'click'].forEach((type) => {
      window.addEventListener(type, stopListening, {
        once: true,
        capture: true,
      });
    });
    // 监听页面隐藏事件，上报指标
    window.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'hidden') {
        stopListening();
      }
    }, { once: true, capture: true });

  } catch (error: any) {
      // 不支持PerformanceObserver
      trackEvent('tech_sofi_catch_error', {
          source: 'performance.no_support',
          data: JSON.stringify(error),
      });
  }
})()